"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = ({
  className
}) => {
  return _react.default.createElement(_SvgIcon.default, {
    className: className
  }, _react.default.createElement("path", {
    d: "M8.99242 9.366V8.619H3.84442V9.366H6.01342V15H6.83242V9.366H8.99242ZM14.6455 15L12.4225 11.139L14.6365 8.619H13.6465L10.7755 11.895V8.619H9.96547V15H10.7755V13.02L11.8555 11.787L13.7005 15H14.6455ZM19.8665 13.668V12.975H19.0205V11.112H18.2465V12.975H16.0415L18.5795 8.745H17.7515L15.2855 12.84V13.668H18.2465V15H19.0205V13.668H19.8665Z",
    fill: "black"
  }), _react.default.createElement("path", {
    d: "M1 1H23V-1H1V1ZM23 1V23H25V1H23ZM23 23H1V25H23V23ZM1 23V1H-1V23H1ZM1 23L1 23H-1C-1 24.1046 -0.104568 25 1 25V23ZM23 23L23 23V25C24.1046 25 25 24.1046 25 23H23ZM23 1L23 1H25C25 -0.10457 24.1046 -1 23 -1V1ZM1 -1C-0.10457 -1 -1 -0.104568 -1 1H1L1 1V-1Z",
    fill: "#999999"
  }));
};

exports.default = _default;
module.exports = exports.default;